<template>
    <div id="subpage">
        <el-col :span="24" class="warp-breadcrum">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>
                    <b>首页</b>
                </el-breadcrumb-item>
                <el-breadcrumb-item to="/doctor/index">我的课程</el-breadcrumb-item>
                <el-breadcrumb-item>资料下载</el-breadcrumb-item>
            </el-breadcrumb>
        </el-col>
        <div class="content">
            <div class="xcx-head">
                <div style="display: flex">
                    <span>我的资料</span>
                </div>
            </div>
            <div class="xcx-content">

                <div class="data-item h90 dis_jcsb border-bottom cur_p flex" v-for="(v, i) in tableData" :key="i">
                    <div class="flex txt-6F8199 font16 col7">
                        <img class="w42 mr25" src="../../../public/images/icon/21.png" alt="" />
                        <div class="col1">
                            <div class="data-item-title txt-233650 font16 truncate">{{ v.title }}</div>
                            <div class="txt-9097AB font14 mt15">
                                <span class="mr60">更新时间：{{ v.updated_at }}</span>
                                <span class="mr60">{{ v.size }}</span>
                                <span>下载数：{{ v.click }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="">
                        <el-button @click="downLoadFile(v, 0)" type="primary" round icon="el-icon-view">预览</el-button>
                        <el-button @click="downLoadFile(v, 1)" type="danger" round icon="el-icon-download">下载
                        </el-button>
                    </div>
                </div>

                <!--分页-->
                <div class="paging">
                    <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
                        layout="total, prev, pager, next" :total="count" :page-size="limit"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            tableData: [],
            page: 0,
            count: 0,
            limit: 7,
        };
    },

    //进入页面加载
    mounted: function () {
        var that = this;
        that.getList();
    },
    methods: {
        downLoadFile(v, s) {
            let that = this;
            that.axios.post("/getDownloadUrl", { id: v.id }).then((res) => {
                if (res.code == 200) {
                    if (s == 1) {
                        window.open(res.data.urls);
                    } else {
                        window.open(res.data.filepath);
                    }
                } else {
                    that.$message({
                        type: "error",
                        message: `操作提示: ${res.msg}`,
                    });
                    return;
                }
            });
        },

        /**
         * 下一页
         */
        handleCurrentChange(currentPage) {
            var that = this;
            that.page = currentPage;
            that.getList();
        },

        /**
         * 获取列表
         */
        getList() {
            let that = this;
            let formData = {};
            var curr_page = sessionStorage.getItem("curr_page");
            that.page = curr_page ? curr_page - 0 : that.page;
            formData.page = that.page;
            formData.column_id = that.column_id;
            formData.limit = that.limit;
            that.axios.post("/getMyAllDownload", formData).then((res) => {
                if (res) {
                    that.tableData = res.data.data;
                    that.count = res.data.total;
                    that.page = curr_page ? curr_page : that.page;
                    curr_page ? sessionStorage.removeItem("curr_page") : "";
                    that.loading = false;
                }
            });
        },
    },
};
</script>
<style scoped>
.flex-grow {
    flex-grow: 1;
}

.xcx-head {
    margin-bottom: 10px;
}

.flex-shrink-0 {
    flex-shrink: 0;
}

.inline-block {
    display: inline-block;
}

.border-bottom {
    border-bottom: 1px #ccc dashed;
}

.bg-2A2D31 {
    background-color: #2A2D31;
}

.bg-26292C {
    background-color: #26292C;
}

.txt-6F8199 {
    color: #6F8199;
}

.txt-233650 {
    color: #233650;
}

.txt-9097AB {
    color: #9097AB;
}

.data-item:hover {
    color: #3078FF;
    background: #F0F3F7;
}

.truncate {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.w42 {
    width: 43px;
    height: 52px;
}

.w14 {
    width: 14px;
}

.w161 {
    width: 125px;
}

.h90 {
    height: 90px;
}

.h55 {
    height: 55px;
    align-items: center;
}

.h400 {
    height: 400px;
}
</style>